import React, {Fragment, useEffect, useState} from "react";
import Wizard from "./Wizard";
import PaperDetailsPage from "./PaperDetailsPage";
import AuthPage from "./AuthPage";
import PriceCalculationPage from "./PriceCalculationPage";
import {connect, useDispatch, useSelector} from "react-redux";
import {clearFiles} from "../actions/FileActions";
import arrayMutators from 'final-form-arrays'
import {getOrderOptions} from "../actions/OrderOptionActions";
import {getAuthOptions} from "@core/actions/AuthOptionActions";
import NightModeToggle from "../../auth/components/NightModeToggle";
import {getUser} from "../../core/actions/UserActions";
import useAuth from "../../core/hooks/useAuth";
import {getPayments} from "../actions/PaymentActions";
import useOrderSubmit from "../hooks/useOrderSubmit";
import {ORDER_FORM_TYPE_OUTER} from "../constants/OrderFormTypeConstant";
import Preloader from "../../core/components/Loader/Preloader";
import BlockingLoader from "../../core/components/Loader/BlockingLoader";
import {siteSetData} from "Trnsc/core/actions/SiteActions";
import {STYLE_HIDE_BACKGROUND} from "@common/constants/hideBackgroudShowSummary";
import cookieStorage from "@common/helpers/cookieStorage";
import useIsMobile from "../helpers/MobileHelper";
import {setShowSummary} from "../actions/SummaryActions";
import {checkCouponCode} from "../actions/ApplyFieldActions";
import FormPageStyles from "./FormPageStyles";

const initialCouponParam = new URLSearchParams(window.location.search).get('coupon');
const couponErrorMessage = "Please enter a valid promo code";

function Index() {
    const {data: orderOptions, loading} = useSelector(state => state.orderOptions);
    const showSummary = useSelector(state => state.summary.status);
    const {requestPayment} = useOrderSubmit();
    const handleAuth = useAuth();
    const dispatch = useDispatch();
    const isMobile = useIsMobile();
    const [orientation, setOrientation] = useState(window.orientation);
    const {user} = useSelector(state => state.user);
    const [hasAuthKey, setHasAuthKey] = useState(cookieStorage.has("_authKey"));

    useEffect(() => {
        dispatch(getAuthOptions());
        dispatch(getUser());
        dispatch(getPayments());
        dispatch(clearFiles());
        dispatch(getOrderOptions());
    }, [])

    useEffect(() => {
        if (initialCouponParam) {
            dispatch(checkCouponCode('coupon', initialCouponParam, couponErrorMessage));
        }
    }, [dispatch])

    useEffect(() => {
        if (hasAuthKey && !user) {
            dispatch(getUser());
        }

        const handleCookieChange = () => {
            setHasAuthKey(cookieStorage.has("_authKey"));
        };

        window.addEventListener('click', handleCookieChange);
        window.addEventListener('input', handleCookieChange);

        return () => {
            window.removeEventListener('click', handleCookieChange);
            window.removeEventListener('input', handleCookieChange);
        };
    }, [hasAuthKey]);

    useEffect(() => {
        const handleOrientationChange = () => {
            if (window.orientation !== orientation) {
                const el = document.getElementById('form-app');
                if (el) {
                    setTimeout(() => {
                        el.scrollIntoView({behavior: "smooth", block: "start"});
                    }, 500);
                }
                setOrientation(window.orientation);
            }
        };

        window.addEventListener('orientationchange', handleOrientationChange);

        return () => {
            window.removeEventListener('orientationchange', handleOrientationChange);
        };
    }, [orientation]);

    const getDefaultAuthorCategoryValue = () => {
        let value = undefined;
        Object.keys(orderOptions.writerLevel).map(key => {
            if (orderOptions.writerLevel[key].checked) {
                value = orderOptions.writerLevel[key].value;
            }
        })

        return value;
    }

    const getDefaultFreeAuthorCategoryValue = () => {
        let value = undefined;
        Object.keys(orderOptions.freeWriterLevel).map(key => {
            if (orderOptions.freeWriterLevel[key].checked) {
                value = orderOptions.freeWriterLevel[key].value;
            }
        })

        return value;
    }

    if (orderOptions && orderOptions.deadlines[0]) {
        var getInitialValues = {
            topic: 'Writer\'s choice',
            typeOfPaper: undefined,
            subject: undefined,
            deadline: orderOptions.deadlines[0].value,
            exactDeadline: orderOptions.deadlines[0].value,
            spacing: orderOptions.spacing.find(item => item.checked).value,
            academicLevel: orderOptions.academicLevel[2].value,
            page: orderOptions.limits.page.default,
            slide: orderOptions.limits.slide.default,
            visualPiece: orderOptions.limits.visualPiece.default,
            question: orderOptions.limits.question.default,
            problem: orderOptions.limits.problem.default,
            source: 0,
            vipSupport: Number(orderOptions.features.vipSupport.checked),
            freeVipSupport: Number(orderOptions.features.freeVipSupport.checked),
            plagiarismReport: Number(orderOptions.features.plagiarismReport.checked),
            freePlagiarismReport: Number(orderOptions.features.freePlagiarismReport.checked),
            abstractPage: Number(orderOptions.features.abstractPage.checked),
            freeAbstractPage: Number(orderOptions.features.freeAbstractPage.checked),
            editorCheck: Number(orderOptions.features.editorCheck.checked),
            freeEditorCheck: Number(orderOptions.features.freeEditorCheck.checked),
            paperFormat: orderOptions.paperFormat[0].value,
            usedSource: Number(orderOptions.features.usedSource.checked),
            authorCategory: getDefaultAuthorCategoryValue(),
            freeAuthorCategory: getDefaultFreeAuthorCategoryValue(),
            formType: ORDER_FORM_TYPE_OUTER,
            coupon: initialCouponParam || '',
        };
    }

    const handleShowSummary = () => {
        dispatch(setShowSummary(!showSummary));

        if (!showSummary) {
            document.body.classList.add('no-scroll');
            document.documentElement.classList.add('no-scroll');
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
            document.documentElement.style.height = '100%';
            document.body.style.height = '100%';
        } else {
            document.body.classList.remove('no-scroll');
            document.documentElement.classList.remove('no-scroll');
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
            document.documentElement.style.height = '';
            document.body.style.height = '';
        }
    }

    if (loading || !orderOptions?.deadlines?.[0]) {
        return <Fragment>
            <FormPageStyles/>
            <BlockingLoader/>
        </Fragment>;
    }

    return <Fragment>
        <FormPageStyles/>
        <header className="header-of">
            <div className="container_v3">
                <a target="_blank" href="/" className="header__logo">
                    <img src="/account/img/logo.svg" alt="logo" className="logo-link"/>
                </a>
                <button className="header-of__sidebar-link" onClick={handleShowSummary}>
                    {showSummary ? 'Close' : 'Order details'}
                    <span className={`header-of__sidebar-link-icon ${showSummary ? 'active' : ''}`}>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_588_852)">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M4.99943 5.88421L7.20901 8.0938C7.32626 8.21104 7.48528 8.27691 7.65109 8.27691C7.81691 8.27691 7.97593 8.21104 8.09318 8.0938C8.21042 7.97655 8.27629 7.81753 8.27629 7.65171C8.27629 7.4859 8.21042 7.32688 8.09318 7.20963L5.88276 5.00005L8.09276 2.79046C8.15079 2.73241 8.19681 2.66349 8.22821 2.58765C8.2596 2.51181 8.27575 2.43052 8.27573 2.34844C8.27571 2.26636 8.25952 2.18508 8.2281 2.10925C8.19667 2.03343 8.15061 1.96453 8.09255 1.9065C8.0345 1.84848 7.96558 1.80245 7.88974 1.77106C7.8139 1.73966 7.73261 1.72352 7.65053 1.72353C7.56845 1.72355 7.48717 1.73974 7.41134 1.77117C7.33552 1.8026 7.26662 1.84866 7.20859 1.90671L4.99943 4.1163L2.78984 1.90671C2.73222 1.84699 2.66328 1.79935 2.58704 1.76656C2.5108 1.73376 2.4288 1.71648 2.34581 1.71572C2.26282 1.71496 2.18052 1.73074 2.10369 1.76213C2.02687 1.79352 1.95706 1.83989 1.89835 1.89855C1.83964 1.9572 1.7932 2.02696 1.76174 2.10376C1.73028 2.18055 1.71443 2.26285 1.71511 2.34583C1.71579 2.42882 1.73299 2.51084 1.76571 2.58711C1.79843 2.66338 1.84601 2.73236 1.90568 2.79005L4.11609 5.00005L1.90609 7.21005C1.84643 7.26773 1.79885 7.33672 1.76613 7.41298C1.73341 7.48925 1.71621 7.57127 1.71553 7.65426C1.71484 7.73725 1.7307 7.81954 1.76216 7.89633C1.79362 7.97313 1.84006 8.04289 1.89877 8.10154C1.95748 8.1602 2.02729 8.20657 2.10411 8.23796C2.18093 8.26935 2.26324 8.28513 2.34623 8.28437C2.42921 8.28361 2.51122 8.26633 2.58746 8.23354C2.66369 8.20075 2.73264 8.1531 2.79026 8.09338L4.99943 5.88421Z"
                                      fill="#56657B"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_588_852">
                                    <rect width="10" height="10" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </span>
                </button>
            </div>
        </header>
        <div className="form-app_v3-side-bg">
            <NightModeToggle/>
        </div>
        <Wizard onSubmit={requestPayment} initialValues={getInitialValues} mutators={arrayMutators}>
            <Wizard.Page>
                <div style={isMobile && showSummary ? STYLE_HIDE_BACKGROUND : {}}></div>
                <PaperDetailsPage/>
            </Wizard.Page>
            <Wizard.Page onBeforeSubmit={handleAuth}>
                <div style={isMobile && showSummary ? STYLE_HIDE_BACKGROUND : {}}></div>
                <AuthPage/>
            </Wizard.Page>
            <Wizard.Page>
                <div style={isMobile && showSummary ? STYLE_HIDE_BACKGROUND : {}}></div>
                <PriceCalculationPage/>
            </Wizard.Page>
        </Wizard>
        <Preloader/>
    </Fragment>
}

export default connect(
    null,
    dispatch => ({
        siteSetData: data => dispatch(siteSetData(data)),
    }),
)(Index)
